"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createTSpan = exports.createSvgElement = exports.SVG_MIME = exports.SVG_NS = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _underscore = _interopRequireDefault(require("underscore"));

var SVG_NS = 'http://www.w3.org/2000/svg';
exports.SVG_NS = SVG_NS;
var SVG_MIME = 'image/svg+xml';
exports.SVG_MIME = SVG_MIME;

var convertString = function convertString(svgDataUri) {
  var svgString = svgDataUri;

  if (/^data:image\/svg\+xml/.test(svgDataUri)) {
    svgString = svgDataUri.split(/,/)[1];
    if (/;base64,/.test(svgDataUri)) svgString = window.atob(svgString);
  }

  return new DOMParser().parseFromString(svgString, SVG_MIME).documentElement;
};

var setAttributes = function setAttributes(node) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _underscore.default.each(attributes, function (value, attrName) {
    var name = attrName === 'className' ? 'class' : attrName;
    node.setAttribute(name, value);
  });

  return node;
};

var createSvgElement = function createSvgElement(elementName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return setAttributes(document.createElementNS(SVG_NS, elementName), attributes);
};

exports.createSvgElement = createSvgElement;

var createTSpan = function createTSpan(text) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tspan = createSvgElement('tspan', attributes);
  tspan.appendChild(document.createTextNode(_underscore.default.escape(text)));
  return tspan;
};

exports.createTSpan = createTSpan;

var SVGBuilder = /*#__PURE__*/function () {
  function SVGBuilder(svgDataUri) {
    (0, _classCallCheck2.default)(this, SVGBuilder);

    if (typeof svgDataUri === 'undefined') {
      this.doc = createSvgElement('svg');
    } else {
      this.doc = convertString(svgDataUri);
    }
  }

  (0, _createClass2.default)(SVGBuilder, [{
    key: "attributes",
    value: function attributes(attrs) {
      setAttributes(this.doc, attrs);
      return this;
    }
  }, {
    key: "css",
    value: function css(embeddedCSS) {
      var styleEl = createSvgElement('style');
      styleEl.appendChild(document.createTextNode(embeddedCSS));
      this.doc.appendChild(styleEl);
      return this;
    }
  }, {
    key: "insertSvg",
    value: function insertSvg(svg) {
      var attributesOverrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var svgDoc = svg;

      if (_underscore.default.isString(svgDoc)) {
        svgDoc = convertString(svgDoc);
      }

      svgDoc = setAttributes(svgDoc, attributesOverrides);
      this.doc.appendChild(svgDoc);
      return this;
    }
  }, {
    key: "text",
    value: function text(txt) {
      var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var textNode = createSvgElement('text', attributes);
      var textArr = [txt];
      if (_underscore.default.isArray(txt)) textArr = txt;

      _underscore.default.each(textArr, function (t) {
        if (_underscore.default.isString(t)) {
          textNode.appendChild(document.createTextNode(t));
        } else {
          textNode.appendChild(t);
        }
      });

      this.doc.appendChild(textNode);
      return this;
    }
  }, {
    key: "box",
    value: function box(attributes) {
      if (_underscore.default.isUndefined(attributes)) throw 'Attributes are required';
      this.doc.appendChild(createSvgElement('rect', attributes));
      return this;
    }
  }, {
    key: "extractText",
    value: function extractText(cssSelector) {
      var foundElement = this.doc.querySelector(cssSelector);
      return foundElement ? foundElement.textContent : null;
    }
  }, {
    key: "document",
    get: function get() {
      return this.doc;
    }
  }, {
    key: "svg",
    get: function get() {
      return new XMLSerializer().serializeToString(this.doc);
    }
  }, {
    key: "dataUrl",
    get: function get() {
      return "data:".concat(SVG_MIME, ";base64,").concat(window.btoa(this.svg));
    }
  }]);
  return SVGBuilder;
}();

exports.default = SVGBuilder;